/**
 * ai 接口
 */
import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  payment40SeasBuyer: data => axios({ baseURL, url: '/api/payment/40seas/buyer', method: 'POST', data }), // 40seas-账号额度申请-唤起申请控件
  payment40SeasBuyerCreditline: params => axios({ baseURL, url: '/api/payment/40seas/buyer/creditline', method: 'GET', params }), // 40seas-获取用户信用额度
  payment40SeasCheckout: paymentId => axios({ baseURL, url: `/api/payment/40seas/checkout/${paymentId}`, method: 'POST' }) // 40seas-唤起40seas支付控件
}
